import { Badge } from "@/components/ui/badge";

export function PilotCard({ debug }: { debug: Record<string, unknown> }) {
  const directive = debug.pilot_directive as string | undefined;
  const phaseTrigger = debug.phase_trigger as string | undefined;
  const ended = debug.ended === true;

  if (!directive && !phaseTrigger && !ended) return null;

  return (
    <div className="mt-1.5 rounded border-l-2 border-violet-500 bg-violet-50 px-2 py-1.5 dark:bg-violet-950/30">
      {directive && (
        <p className="text-[11px] leading-snug text-violet-800 dark:text-violet-300">
          {directive}
        </p>
      )}
      <div className="mt-1 flex flex-wrap gap-1">
        {phaseTrigger && (
          <Badge variant="outline" className="h-4 border-violet-300 px-1 text-[10px] text-violet-700 dark:border-violet-700 dark:text-violet-400">
            {phaseTrigger}
          </Badge>
        )}
        {ended && (
          <Badge variant="destructive" className="h-4 px-1 text-[10px]">
            已结束
          </Badge>
        )}
      </div>
    </div>
  );
}
